var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25159 17L2 11.805L4.39323 9.43758L7.25159 12.2735L15.6068 4L18 6.36744L7.25159 17Z",
    fill: "#05CD99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickIcon);
export default __webpack_public_path__ + "static/media/success-tick-icon.00daf82e649d0708059cda3c0af0c30b.svg";
export { ForwardRef as ReactComponent };